//*******************************************************
import {  Component,
          LOCALE_ID,
          Inject, 
          ViewChild}                      from '@angular/core';

import {  formatDate,  
          FormatWidth,
          getLocaleDateFormat  
      }                                   from '@angular/common';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//**************************************************************
// Devexpress 
import { DxFormComponent }                from 'devextreme-angular';
import { DxDataGridComponent }            from 'devextreme-angular';
import { DxValidationGroupComponent }     from 'devextreme-angular/ui/validation-group';
//**************************************************************
// Field Definitions
import { 
          inviteefield, 
          googleaddress,
          whoseguestinit,
        }                                 from '../../appfirestore/app.fields';
//*******************************************************
// Functions
import { appfunctions  }                  from '../../functions/app.functions';
//*******************************************************
// List Structures
import { liststructures }               from '../../classinjection/app.liststructures'
//**************************************************************

// JQuery 
import 'devextreme/integration/jquery';
import { object } from 'firebase-functions/v1/storage';
//**************************************************************
// TODO - Build the layout of invitee detail information

@Component(
            {
              selector: 'app-cominviteedetail',
              templateUrl: './cominviteedetail.component.html',
              styleUrls: ['./cominviteedetail.component.scss']
            }
          )

//*******************************************************
export class CominviteedetailComponent 
  {
    //*******************************************************
    @ViewChild('grideventinvitee') dataGrid: DxDataGridComponent;
    @ViewChild('gridinitial') dataGridInitial: DxDataGridComponent;
    
    @ViewChild('forminviteename') forminviteename: DxFormComponent;
    @ViewChild('forminviteeaddress') forminviteeaddress: DxFormComponent;
    @ViewChild('forminviteecontact') forminviteecontact: DxFormComponent;
    @ViewChild('forminviteediet') forminviteediet: DxFormComponent;
    @ViewChild('forminviteenameprofile') forminviteenameprofile: DxFormComponent;
    
    @ViewChild('targetOrganiserId', {static: false}) validationOrgId: DxValidationGroupComponent
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;

    // eventinvitee
    subscriptioninvitee: Subscription;
    subscriptioninviteelist: inviteefield[];

     // event google address
     subscriptiongoogleaddress: Subscription;
     subscriptiongoogleaddresslist: googleaddress[];

    // Firestore Paths
    pathinvitee: string = "/eventinvitee/inviteelist" 

    // Array of Data
   // formData: any = {};
    //formData: inviteefield;
    formData: Array<inviteefield> = [];
    statusvaluechange: boolean = false;

    // Invitee Details
    inviteetitle: Array<string> = [];
    seltitle: string;
    inviteeaddress: string;
    googleaddress: string;

    // Diets
    dietlist: Array<string> = [];
    seldiet: string;

    // Button
    selButton: number;
    buttondisable: boolean = true;

    // Popup
    popuptitle: string;
    popupinviteeVisible:  boolean = false;
    popupaddressVisible:  boolean = false;
    popupcontactVisible:  boolean = false;
    popupdietVisible:     boolean = false;

    // Toast Switches
    toastFileMessage: string = '';
    toasttypeerror: string = 'error';
    toastdisplaytime: number = 3000
    toastVisible: boolean = false;
    toastwidth: string = '240';
    toastposX: number = 180;
    toastposY: number = 20;

    // Row Selected
    rowdata: any;
    rowselect: boolean = false;

    // Address Details
    selunitno:     string = '0';
    selstreetno:   string = '';
    selstreet:     string = '';
    selsuburb:     string = '';
    selpostcode:   string = '';
    selstate:      string = '';
    // Po Box Details
    selpobox:      string = '';
    selposuburb:   string = '';
    selpopostcode: string = '';
    selpostate:    string = '';

    seltypes = 
    [
      "Contact", 
      "Seating",
      "Other",
      "None"
    ];

    whoseguest: Array<whoseguestinit> = []; // Empty Array
    whoseguestinitlist: Array<string> = [];
                     
    addressOptions: any = {
                            inputAttr: {
                                          autocomplete: "new-address"
                                        }
                          };

    focusedRowKey: number = 0;

    //gridColumns: any = ['id','initial'];
    gridColumns: any = ['initial', 'fullname'];

    organiserid: string = '';

    test: string = '';
    rowcurrentid: string = '';

    labelTemplates: any[];

    apiRoot: string = '';
    //*******************************************************
    constructor (
                  private routernavigate: Router,
                  private _Activatedroute:ActivatedRoute,
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions,
                  private liststruct: liststructures,
                  @Inject(LOCALE_ID) public locale: string
                ) 
       { 

          this.saveClick                = this.saveClick.bind(this);
          this.cancelClick              = this.cancelClick.bind( this);
          this.transferaddressclick     = this.transferaddressclick.bind( this);

          this.labelTemplates = [
                                  { name: 'name',       icon: 'dx-icon-user' },
                                  { name: 'position',   icon: 'dx-icon-info' },
                                  { name: 'date',       icon: 'dx-icon-event' },
                                  { name: 'address',    icon: 'dx-icon-home' },
                                  { name: 'phone',      icon: 'dx-icon-tel' },
                                  { name: 'email',      icon: 'dx-icon-email' },
                                  { name: 'mobile',     icon: 'fa-solid fa-mobile-retro' },
                                  { name: 'note',       icon: 'fa-regular fa-note-sticky'},
                                  { name: 'food',       icon: 'fa-solid fa-bowl-food'},
                                  { name: 'road',       icon: 'fa-sharp fa-solid fa-road'},
                                  { name: 'letter',     icon: 'fa-solid fa-square-envelope'},
                                  { name: 'address',    icon: 'fa-solid fa-address-card'},
                                  { name: 'location',   icon: 'fa-solid fa-location-dot'}
                                ];

       }
     //*******************************************************
     ngOnInit(): void 
       {
          //---------------------------------------------------------------------------------------------
          // EventId
          this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
          // Form Height
          this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
          //---------------------------------------------------------------------------------------------
          // Establish Connection to event -> eventparticipant
          this.firestoredata.loadeventinvitee( this.eventid );

          this.subscriptioninvitee = this.firestoredata.geteventinvitee().subscribe
            ( items => 
              { 
                this.subscriptioninviteelist = items;
                //console.log( this.subscriptioninviteelist )
              }
            )
        //---------------------------------------------------------------------------------------------
        // Establish Connection to Google Address List    
        this.firestoredata.loadgoogleaddress( this.eventid );

        this.subscriptiongoogleaddress = this.firestoredata.geteventgoogleaddress().subscribe
          ( items => 
            { 
              this.subscriptiongoogleaddresslist = items;
              // console.log( this.subscriptiongoogleaddresslist )
            }
          )      
        //---------------------------------------------------------------------------------------------
        // Title List
        this.inviteetitle = this.liststruct.getTitle();
        //---------------------------------------------------------------------------------------------
        // Diet List     
        this.dietlist = this.liststruct.getDietary();
        //---------------------------------------------------------------------------------------------
        // Event Organiser Initials
        this.firestoredata.buildwhoseguestdetails( this.eventid );
        this.whoseguest = this.firestoredata.geteventparticipantdetails();

        this.firestoredata.buildwhoseguestinit( this.eventid );
        this.whoseguestinitlist = this.firestoredata.geteventparticipantinit();
        //---------------------------------------------------------------------------------------------                  
     }
     //*******************************************************
     ngOnDestroy() 
      {
        this.subscriptioninvitee.unsubscribe() 
      }
     //******************************************************* 
    onrowclick( event: any )
      { 

        this.rowselect      = true;             // Indicate that Datagrid - invitee has been selected
        this.buttondisable  = false;            // Enable Invitee form buttons

        console.log(  this.buttondisable )
        // Capture Select Row Data Id
        this.focusedRowKey = event.data.id;  // Register Data Row - id
        // Save data
        this.inviteedataprofile( 10, event ) // Store Data Row Data
    
      }
    //*******************************************************
    onrowchange( event: any )
        {
          this.rowselect     = true;                        // Indicate that Datagrid - invitee has been selected
         
          this.buttondisable = true;                        // Disable Invitee form buttons
      
         // this.dataGrid.instance.clearSelection();      
          
          // Capture Select Row Data Id
          this.focusedRowKey = event.row.data.id;       // Register Data Row - id
          // Save data
          this.inviteedataprofile( 20, event )          // Store Data Row Data

        }
    //*******************************************************
    onrowadd( event: any )
      {

      }
    //*******************************************************
    onCellHoverInvitee( event: any )
      {
        //**************************************************************
        var componentid   =  event.element[0].id
       //**************************************************************
        if ( componentid == "grideventinvitee" )
          {
            if (  event.rowType == 'data' && event.eventType == 'mouseover' )
              {  
                
                if ( this.rowcurrentid != event.data.id )
                  {
                    this.rowcurrentid = event.data.id;

                   // console.log( event.data )
                  }
              }
          }

      }
    //*******************************************************
    // Gather Invitee Profile for Editing
    inviteedataprofile( settype: number,  seldata: any)
        {
          switch ( settype )
            {
              // Row Click
              case 10:
                {
                 
                  this.formData        = seldata.data;
                  this.organiserid     = seldata.data.whoseparticipant;
                  this.rowdata         = seldata.data
                  break;

                }

              // Row Change
              case 20:
                {
                  this.formData        = seldata.row.data;
                  this.organiserid     = seldata.row.data.whoseparticipant;
                  this.rowdata         = seldata.row.data
                  break; 
                }

            }
          //---------------------------------------------------------------------------------------------
          // Update Invitee Profile





          //---------------------------------------------------------------------------------------------

        }
    //*******************************************************
    // Save Invitee Details
    saveClick()
      {
        switch ( this.selButton )
          {
            //---------------------------------------------------------------------------------------------
            case 10: // Add New Invitee
              {
                //---------------------------------------------------------------------------------------------
                // Validation for OrganiserId
                let orgidresult = this.validationOrgId.instance.validate();
                // Validation for formData
                let validresult = this.forminviteename.instance.validate();
                //---------------------------------------------------------------------------------------------
                if ( validresult.isValid && orgidresult.isValid )
                  {
                  
                    var newinvitee: any;
                    newinvitee =  this.formData

                    newinvitee.id                   =  this.appfunction.createuniqueid(4)
                    newinvitee.whoseparticipant     = this.organiserid;
                    //---------------------------------------------------------------------------------------------
                    // Save Data - Firestore
                    this.firestoredata.AddUpdateInvitee( this.selButton, this.eventid, newinvitee, '' );
                    //---------------------------------------------------------------------------------------------
                    // Set Focus to the New Addded Row
                    this.dataGrid.instance.clearSelection();
                    this.dataGrid.instance.option("focusedRowKey",  -1 );
  
                    // Focus Row when inserted
                    setTimeout(() => {
                                        this.dataGrid.instance.option("focusedRowKey",  newinvitee.id  );
                                      }, 
                                      100
                              );
                    //---------------------------------------------------------------------------------------------
                    this.buttondisable  = false;
                    this.popupinviteeVisible   = false;
                    //---------------------------------------------------------------------------------------------                 
                  }
                else
                  {
                    console.log('Failed')
                  }

                break;
              }
            //---------------------------------------------------------------------------------------------
            case 20: // Update Invitee
              {
                // Validation for OrganiserId
                let orgidresult = this.validationOrgId.instance.validate();
                // Validation for formData
                let validresult = this.forminviteename.instance.validate()
 
                if ( validresult.isValid && orgidresult.isValid )
                  {
                      this.firestoredata.AddUpdateInvitee( this.selButton, this.eventid, this.formData, '' );

                      this.dataGrid.instance.focus();
                  }

                this.buttondisable = true;
                    
                this.popupinviteeVisible = false;

                break;
              }
            //---------------------------------------------------------------------------------------------
            case 30: // Update Address Details
              {
                  // Save Address Details
                  //  this.appfunction.googlevalidateaddressTest( '22 John Street Ashfield NSW Australia').subscribe((r)=>console.log(r))

                  // Validation for formData
                  let validresult = this.forminviteeaddress.instance.validate()

                  if ( validresult.isValid )
                    {

                      this.googleaddress = '';
                      this.rowdata = this.formData;
                      this.inviteeaddress = this.rowdata.streetno + '+' + this.rowdata.street  + '+' + this.rowdata.suburb + '+' + this.rowdata.postcode 

                      // Save Address Details
                      this.appfunction.googlevalidateaddressTest( this.inviteeaddress ).subscribe( ( selgoogle)=> {
                                                                                                                     this.googleaddress = selgoogle;

                                                                                                                     console.log( this.googleaddress )

                                                                                                                      // Confirm Google Address
                                                                                                                      if ( this.googleaddress.length > 1 ) 
                                                                                                                        {
                                                                                                                          // Save Details
                                                                                                                          this.firestoredata.AddUpdateInvitee( this.selButton, this.eventid, this.formData, this.googleaddress );
                                                                                                                        }
                                                                                                                      else  
                                                                                                                        {

                                                                                                                          this.toastFileMessage = 'Invalid Street Address';
                                                                                                                          this.toasttypeerror   = 'error';
                                                                                                                          this.toastdisplaytime = 5000;
                                                                                                                          this.toastwidth       = '250';
                                                                                                                          this.toastVisible     = true;
                                                                                                                          this.toastposX        = 180;
                                                                                                                          this.toastposY        = 20;

                                                                                                                        }     
                                                                                                           
                                                                                                          }
                                                                                                  )


                      this.dataGrid.instance.focus();
                    
                    }

                this.buttondisable = true;
                  
                this.popupaddressVisible = false;

                break;
              }  
            //---------------------------------------------------------------------------------------------
            case 40: // Update Contact Details
              {
                // Validation for formData
                let validresult = this.forminviteecontact.instance.validate()

                if ( validresult.isValid )
                  { 
                    // Save Contact Details
                    this.firestoredata.AddUpdateInvitee( this.selButton, this.eventid, this.formData, '' );

                    this.dataGrid.instance.focus();
                    
                  }

                this.buttondisable = true;
                  
                this.popupcontactVisible = false;
              
                break;
              }
            //---------------------------------------------------------------------------------------------
            case 50: // Update Dietary
              {
                // Save Contact Details
                this.firestoredata.AddUpdateInvitee( this.selButton, this.eventid, this.formData, '' );

                this.dataGrid.instance.focus();

                this.buttondisable = true;
              
                this.popupdietVisible = false;

                break;
              }
            //---------------------------------------------------------------------------------------------
          }

      }
    //*******************************************************
    cancelClick()
      {
        // Cancel Button
        //---------------------------------------------------------------------------------------------
        switch ( this.selButton )
          {
            //---------------------------------------------------------------------------------------------
            case 10:  // cancel-Add Invitee Details
                {
                  console.log('cancel-Add Invitee')

                  if ( this.subscriptioninviteelist.length == 0 )
                    {
                      this.buttondisable  = true;
                    }
                  else
                    {
                      
                      //if (( this.rowselect ) && ( this.dataGrid.instance.getSelectedRowsData().length == 1 ))
                      if ( this.rowselect )
                        {
                          // Focus
                          this.buttondisable  = true;

                          // Focus Row when cancel from Add Invitee
                          this.dataGrid.instance.clearSelection();
                          this.dataGrid.instance.option("focusedRowKey",  -1 );
                          setTimeout(() => {
                                          this.dataGrid.instance.option("focusedRowKey",  this.focusedRowKey  );
                                          }, 100
                                    );

                        }
                      else
                        {
                          
                        }

                    }

                  this.popupinviteeVisible = false;

                  break;
                }
            //---------------------------------------------------------------------------------------------
            case 20:    // cancel-Invitee Details
            case 30:    // cancel Address Details
            case 40:    // cancel-Contact Details
            case 50:    // cancel-Dietary Details
                {
                  // Trigger a refresh of the DataGrid when Cancel is selected
                  // Not for Add a Invitee
                  //---------------------------------------------------------------------------------------------
                  if ( this.statusvaluechange )
                    {
                      //---------------------------------------------------------------------------------------------
                      this.firestoredata.commitbatchupdate( 
                                                              this.pathinvitee, 
                                                              this.eventid,
                                                              this.focusedRowKey.toString(),
                                                              'triggerrefresh', 
                                                              this.appfunction.createuniqueid(3)
                                                          );  

                      // Focus Row when cancel
                      this.dataGrid.instance.clearSelection();
                      this.dataGrid.instance.option("focusedRowKey",  -1 );
                      setTimeout(() => {
                                      this.dataGrid.instance.option("focusedRowKey",  this.focusedRowKey  );
                                      }, 100
                                );
                    
                    }

                    this.buttondisable = true;

                    this.dataGrid.instance.focus();  
                  //---------------------------------------------------------------------------------------------
                  switch ( this.selButton )
                    {
                      case 20: // Invitee Form
                          {
                            this.popupinviteeVisible = false;
                            break;
                          }

                      case 30: // Address Form
                          {
                            this.popupaddressVisible = false;
                            break;
                          }

                      case 40: // Contact Form
                          {
                            this.popupcontactVisible = false; 
                            break;
                          }

                      case 50: // Dietary Form
                          {
                            this.popupdietVisible = false;
                            break;
                          }
                    }
                  //---------------------------------------------------------------------------------------------  

                  break;
                }
              //--------------------------------------------------------------------------------------------- 
          }

        this.dataGrid.instance.focus();
        
      }
    //*******************************************************
    formDatafldchange( event: any )
      {
        // Formdata has changed
        this.statusvaluechange = true;
      }
    //*******************************************************
    inviteeform( event: any, seloption: number)
       {
          var status: boolean

          this.selButton          = seloption;
          this.statusvaluechange  = false;      // Detect any changes it formdata fields
          //---------------------------------------------------------------------------------------------
          // Determine whether a ROW is selected when its not a ADD option
          if ( this.selButton  != 10 )
            {
              
              if ( this.rowselect ) 
                {
                  status             = true;
                }
              else
                {
                  status             = false; 
                }
            }
          else
            {
              console.log( 'add')
            }
          //---------------------------------------------------------------------------------------------
          switch ( seloption )
            {
              //---------------------------------------------------------------------------------------------
              // Add Invitee
              case 10:
                  {
                  
                    // Set Inputs to null values
                    this.formData = [];

                    this.organiserid  = '';
                    this.seltitle     = '';

                    this.popuptitle           = 'Add Invitee';
                    this.popupinviteeVisible  = true;
                    this.buttondisable        = true;

                    break;  
                  }
              //---------------------------------------------------------------------------------------------
              // Invitee Details
              case 20:
                {
                  if ( status )
                    {
                        this.popuptitle           = 'Invitee Details';
                        this.popupinviteeVisible  = true;
                    }

                  break;  
                    
                }
              //---------------------------------------------------------------------------------------------
              // Address Details
              case 30:
                {

                  if ( status )
                    {
                      //---------------------------------------------------------------------------------------------
                      // Reset Validation when opening Pop Up
                      let validresult = this.forminviteeaddress.instance.validate()

                      if ( validresult.isValid == false )
                        {
                          this.forminviteeaddress.instance.resetValues(); 
                          this.selunitno = '0';
                        }
                       
                      else
                        {
                          // Set Values
                         // this.selstreet = this.rowdata.street
                        }
                      //---------------------------------------------------------------------------------------------  
                      this.popuptitle           = 'Address Details';
                      this.popupaddressVisible  = true;
                    }
                    
                  break;  
          
                }
              //---------------------------------------------------------------------------------------------
              // Contact Details
              case 40:
                {

                  if ( status )
                    {
                      this.popuptitle             = 'Contact Details';
                      this.popupcontactVisible    = true;
                    }

                  break;  
                 
                }
              //---------------------------------------------------------------------------------------------
              // Diet Details
              case 50:
                {

                  if ( status )
                    {
                      this.popuptitle             = 'Dietary Details';
                      this.popupdietVisible       = true;
                    }

                  break;  
                 
                }
              //---------------------------------------------------------------------------------------------
            }

       }
    //*******************************************************
    editorPreparing( event: any )
       {
            
          if (  event.rowType == "data"  && 
          event.column.command =="edit" )

            {
            
              var $links = event.cellElement.find(".dx-link");
              //$links.filter(".dx-link-delete").remove();
              $links.filter(".dx-link-edit").remove();
            }
         
          }
    //*******************************************************
    dropDownInitOpen( event: any )
      {

       // console.log( this.organiserid )

        this.dataGridInitial.instance.clearSelection();
        this.dataGridInitial.instance.option("focusedRowKey",  this.organiserid );
        this.dataGridInitial.instance.focus();

      }
    //*******************************************************
    rowclickinitial( event: any )
      {
        this.organiserid                = event.data.id;
      //  this.formData.whoseparticipant  = this.organiserid;
      }
    //*******************************************************
    validatetextinput(e): boolean
      {
        var textinput: string
          
        textinput = e.value;
        return ( textinput.length != 0 )
  
      }
    //*******************************************************
    // Label columns widths
    leftposstreetno( whatformat: number) 
      {  
        switch ( whatformat )
          {
            case 1:
                {
                  return "leftposstreetno";  
                  
                }

            case 10:
              {
                return "leftposstreet";    
              }

            case 20:
                {
                  return "leftposstate";    
                }

          }

        return 1;
       
      } 
    //*******************************************************
    transferaddressclick( event )
      {
        // Street Address
        this.selstreetno  = '0';
        this.selstreetno  = event.row.data.streetno;
        this.selstreet    = event.row.data.street;
        this.selsuburb    = event.row.data.suburb;
        this.selpostcode  = event.row.data.postcode;
        this.selstate     = event.row.data.state;

        // If there is NO input in PO BOX, populate the PO suburb, PO postcode and PO state with 
        // Address equivalents
        if ( this.selpobox.length == 0 )
          {
            this.selposuburb    = this.selsuburb;
            this.selpopostcode  = this.selpostcode;
            this.selpostate     = this.selstate;
          }

      }
    //*******************************************************
    customizeItem(item: any) {
      if (item.dataField === 'title') {
        item.borderStyle = 'solid'; // Change to 'solid' for straight lines
      }
    }
   

  }

  
  


  
